<style lang="less" scoped></style>
<template>
  <a-dropdown :trigger="['hover']" class="content-head-dropdown">
    <a-button @click.prevent> {{ current }}<DownOutlined /> </a-button>
    <template #overlay>
      <a-menu>
        <a-menu-item key="all" @click.prevent="handleClick('all')">
          すべて
        </a-menu-item>
        <template
          v-for="productCategory in productCategories"
          :key="productCategory.id"
        >
          <a-menu-item @click.prevent="handleClick(productCategory.id)">
            {{ productCategory.name }}
          </a-menu-item>
        </template>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script lang="ts">
import { computed, defineComponent, unref, SetupContext } from "vue";
import { useResult } from "@vue/apollo-composable";
import { useGetManyProductCategoryQuery } from "@/client/modules/api";
import { GetManyProductCategoryQuery } from "@/client/schema";
import { DownOutlined } from "@ant-design/icons-vue";

type Props = {
  value: string;
};

export default defineComponent({
  components: {
    DownOutlined,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  emits: ["update:value", "change"],
  setup(props: Props, { emit }: SetupContext) {
    const { result } = useGetManyProductCategoryQuery({});

    const productCategories =
      useResult<GetManyProductCategoryQuery, "productCategories">(result);

    const current = computed((): string => {
      if (!props.value) return "すべて";
      return (
        unref(productCategories)?.find(
          (productCategory) => productCategory.id === props.value
        )?.name || "すべて"
      );
    });

    const handleClick = (key: string) => {
      //emit("update:value", key);
      emit("change", key);
    };

    return {
      productCategories,
      handleClick,
      current,
    };
  },
});
</script>
